import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { EnvironmentApi } from '@env0/environment-service/api';

export default (client: HttpClient) => ({
  getEnvironmentsWithOutputsForProject: async (projectId: string) =>
    client
      .get<EnvironmentApi.GetEnvironmentsWithOutputs.Response>(`environment-outputs/by-environment`, {
        params: { projectId }
      })
      .then(returnData)
});
